import type { ComputedRef } from 'vue'
import type { BaseTailwindColor } from '#shared/types/elementsUi'

export interface FieldColorInjection {
  color?: ComputedRef<BaseTailwindColor | undefined>
}

export function useInjectedColor() {
  const $field = inject($FieldColor, undefined)

  return {
    color: $field?.color
  }
}
